import { render, staticRenderFns } from "./TarimaFormComponent.vue?vue&type=template&id=09134713&scoped=true&"
import script from "./TarimaFormComponent.vue?vue&type=script&lang=js&"
export * from "./TarimaFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./TarimaFormComponent.vue?vue&type=style&index=0&id=09134713&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09134713",
  null
  
)

export default component.exports